import { IProduct } from 'shared/map-search/types/analytics';
import { EDealType, EEntityType } from 'shared/map-search/types/chatModal';

import { ITypedReduxAction } from '../../types/redux/actionType';

export enum EChatModalActionType {
  Open = 'chatModal/open',
  Close = 'chatModal/close',
  SetOpenAfterAuth = 'chatModal/setOpenAfterAuth',
}

export type TOpenChatModalPayload = {
  defaultMessage?: string;
  shouldSendDefaultMessage?: boolean;
  offerId?: number;
  gaLabel?: string;
  dealType?: EDealType;
  offerType?: EEntityType;
  authorId?: number | null;
  product?: IProduct;
  isDotPin?: boolean;
};
export type TSetOpenAfterAuthPayload = {
  defaultMessage?: string;
  shouldSendDefaultMessage?: boolean;
  offerId?: number;
  gaLabel?: string;
  dealType?: EDealType;
  offerType?: EEntityType;
  authorId?: number | null;
  product?: IProduct;
  isDotPin?: boolean;
};

export type TChatModalOpen = ITypedReduxAction<EChatModalActionType.Open, TOpenChatModalPayload>;
export type TChatModalClose = ITypedReduxAction<EChatModalActionType.Close>;
export type TChatModalSetOpenAfterAuth = ITypedReduxAction<
  EChatModalActionType.SetOpenAfterAuth,
  TSetOpenAfterAuthPayload
>;

export type TChatModalActions = TChatModalOpen | TChatModalClose | TChatModalSetOpenAfterAuth;
